<div class="select_lang ml-auto d-inline-block right-0 top-0 language-area responsive-lng pr-2">
  <div class="d-flex align-items-center justify-content-center">
    <button
        (click)="setLang('en')"
        [ngClass]="{
          'active-lang': selected == 'en',
          'text-white': theme === 'dark',
          'text-secondary': theme !== 'dark'
        }"
        class="px-2 cursor-pointer"
        type="button">
      English
    </button>
    <span class="">|</span>
    <button
        (click)="setLang('es')"
        [ngClass]="{
          'active-lang': selected == 'es',
          'text-white': theme === 'dark',
          'text-secondary': theme !== 'dark'
        }"
        class="px-2 cursor-pointer"
        type="button">
      Español
    </button>
  </div>
</div>
